import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  CreateConversationContactRequest,
  WhatsappConversation,
  WhatsappConversationContactResponse,
  WhatsappMessageResponse,
} from '../models/whatsapp.model';

@Injectable({ providedIn: 'root' })
export class WhatsappConversationApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}api/whatsapp`;

  list(limit = 50, offset = 0): Observable<WhatsappConversation[]> {
    let params = new HttpParams()
      .set('limit', String(limit))
      .set('offset', String(offset));
    return this.http.get<WhatsappConversation[]>(`${this.base}/conversations`, {
      params,
    });
  }

  /**
   * Un solo hilo, con el MISMO shape que cada elemento de {@link list}.
   *
   * Sirve para refrescar la conversación abierta sin recargar el listado: ése devuelve 50
   * como mucho y no admite filtrar por id, así que en un negocio con más hilos activos el
   * que está abierto puede caer fuera de la página y no refrescarse nunca.
   *
   * 404 significa a la vez «no existe» y «es de otro negocio»: son indistinguibles por
   * diseño, así que no se puede deducir un problema de permisos de un 404.
   */
  get(conversationId: number): Observable<WhatsappConversation> {
    return this.http.get<WhatsappConversation>(
      `${this.base}/conversations/${conversationId}`
    );
  }

  listMessages(conversationId: number): Observable<WhatsappMessageResponse[]> {
    return this.http.get<WhatsappMessageResponse[]>(
      `${this.base}/conversations/${conversationId}/messages`
    );
  }

  /**
   * Crea a mano la ficha de un hilo que no la tiene, o la vincula si ese número ya tenía
   * una (el backend cruza por dígitos del teléfono: «+51 987654321» y «51987654321» son la
   * misma persona). Es la contrapartida de tener apagada el alta automática.
   *
   * El cuerpo es opcional: sin `fullname` la ficha nace con un marcador y toma el nombre
   * cuando Meta mande el perfil del cliente en el siguiente entrante.
   */
  createContact(
    conversationId: number,
    req: CreateConversationContactRequest = {}
  ): Observable<WhatsappConversationContactResponse> {
    return this.http.post<WhatsappConversationContactResponse>(
      `${this.base}/conversations/${conversationId}/contact`,
      req
    );
  }
}
